import React from 'react'

import clsx from 'clsx'
import './ApplyV2Button.scss'

const baseClass = 'ApplyV2Button'

interface ApplyV2ButtonProps {
    className?: string
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
    isLoading?: boolean
    isDisabled?: boolean
    children?: React.ReactNode
    type?: 'button' | 'submit' | 'reset'
    variant?: 'outline' | 'primary' | 'secondary' | 'tertiary' | 'transparent' | 'white'
    leftIcon?: React.ReactNode
    rightIcon?: React.ReactNode
    size?: 'small' | 'medium' | 'large'
    id?: string
    'ra-data-job-post-id'?: string | number
}

function ApplyV2Button({
    className = '',
    onClick = () => {},
    isLoading = false,
    isDisabled = false,
    children,
    type = 'button',
    variant = 'primary',
    leftIcon,
    rightIcon,
    size = 'medium',
    id,
    'ra-data-job-post-id': raDataJobPostId,
}: ApplyV2ButtonProps) {
    return (
        <button
            className={clsx(baseClass, className, {
                [`${baseClass}__loading`]: isLoading,
                [`${baseClass}__disabled`]: isDisabled,
                [`${baseClass}--${variant}`]: variant,
                [`${baseClass}--${size}`]: size,
                [`${className}--loading`]: isLoading && className,
                [`${className}--disabled`]: isDisabled && className,
                [`${className}--${variant}`]: className && variant,
                [`${className}--${size}`]: className && size,
            })}
            onClick={(e) => {
                if (!isLoading && !isDisabled) {
                    onClick(e)
                }
            }}
            disabled={isDisabled || isLoading}
            type={type}
            id={id}
            ra-data-job-post-id={raDataJobPostId}
            // aria-label="Apply Button"
            // data-testid="apply-v2-button"
            // tabIndex={0}
            // onKeyDown={(e) => {
            //     if (e.key === 'Enter' || e.key === ' ') {
            //         onClick()
            //     }
            // }}
        >
            <div className={`${baseClass}__content`}>
                {leftIcon && !isLoading && (
                    <span
                        className={clsx(`${baseClass}__icon`, `${baseClass}__icon--left`, {
                            [`${baseClass}__icon--loading`]: isLoading,
                            [`${className}__icon--loading`]: isLoading && className,
                        })}
                    >
                        {leftIcon}
                    </span>
                )}
                {children && (
                    <div
                        className={clsx(`${baseClass}__text`, {
                            [`${baseClass}__text--loading`]: isLoading,
                            [`${baseClass}__text--disabled`]: isDisabled,
                            [`${baseClass}__text--${variant}`]: variant,
                            [`${className}__text--loading`]: isLoading && className,
                            [`${className}__text--disabled`]: isDisabled && className,
                            [`${className}__text--${variant}`]: className && variant,
                        })}
                    >
                        {children}
                    </div>
                )}
                {rightIcon && !isLoading && (
                    <span
                        className={clsx(`${baseClass}__icon`, `${baseClass}__icon--right`, {
                            [`${baseClass}__icon--loading`]: isLoading,
                            [`${className}__icon--loading`]: isLoading && className,
                        })}
                    >
                        {rightIcon}
                    </span>
                )}
            </div>
            {isLoading && (
                <span className={`${baseClass}__spinner-wrapper`}>
                    <span className={`${baseClass}__spinner`}></span>
                </span>
            )}
        </button>
    )
}

export default ApplyV2Button
